import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { WaffleFeatureFlagsService } from '@shared/services/feature-flags/waffle-feature-flags.service';

export const featureFlagGuardFactory = (flagName: string): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const featureFlagService = inject(WaffleFeatureFlagsService);

    return featureFlagService.getValue(flagName, false, Boolean) as boolean;
  };
};
